import { FormEvent, useState } from 'react';
import { adminLogin } from '../lib/api';

type Props = { onSuccess: () => void };

export default function AdminLogin({ onSuccess }: Props) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  async function handleSubmit(event: FormEvent) {
    event.preventDefault();
    if (!password) return setError('请输入管理员密码');
    setBusy(true); setError('');
    try { await adminLogin(password); onSuccess(); }
    catch (e: any) {
      setError(e?.body?.error === 'admin_password_not_configured' ? '服务器尚未配置管理员密码' : '密码错误，请重试');
    } finally { setBusy(false); }
  }

  return (
    <div className="admin-login-shell">
      <div className="admin-login-card">
        <div className="login-mark">问</div>
        <h1>问卷管理后台</h1>
        <p>登录后管理问卷，并查询历史填写记录</p>
        <form onSubmit={handleSubmit}>
          <label htmlFor="admin-password">管理员密码</label>
          <input id="admin-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="请输入密码" autoFocus />
          {error && <div className="login-error">{error}</div>}
          <button className="btn btn-primary login-submit" disabled={busy}>{busy ? '登录中…' : '登录后台'}</button>
        </form>
        <div className="login-security">🔒 仅管理员可访问数据记录</div>
      </div>
    </div>
  );
}
